import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [isNavOpen, setIsNavOpen] = useState(false);

  // Toggle the state when the navbar toggle button is clicked
  const toggleNavbar = () => setIsNavOpen(!isNavOpen);

  // Close the navbar when a link is clicked
  const closeNavbar = () => setIsNavOpen(false);

  return (
    <div>
      <div className="header">
        <div className="header-nav">

          <div className="men-nav">
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
              <div className="container-fluid">
                <div className="logo">
                  <Link to={"/"}>
                    <a className="navbar-brand navbar-brand-one" aria-label="Go to WashWoosh homepage">
                      <img
                        className="img-fluid"
                        src="images/logo1.png"
                        data-aos="flip-left"
                        data-aos-easing="ease-out-cubic"
                        data-aos-duration={2000}
                        alt="WashWoosh Logo"
                      />
                    </a>
                  </Link>
                </div>
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleNavbar}
                  aria-controls="navbarSupportedContent"
                  aria-expanded={isNavOpen ? "true" : "false"}
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon" />
                </button>
                <div
                  className={`collapse navbar-collapse ${isNavOpen ? "show" : ""
                    }`}
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                    <li className="nav-item nav-item1">
                      <Link
                        style={{ textDecoration: "none" }}
                        className={location.pathname === "/" ? "active" : ""}
                        to={"/"}
                        onClick={() => {
                          closeNavbar();
                          handleLinkClick();
                        }}
                      >
                        <a
                          className={`nav-link nav-link-one ${location.pathname === "/" ? "active" : ""
                            }`} aria-label="Go to WashWoosh homepage"
                        >
                          <span>Home</span>
                        </a>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        style={{ textDecoration: "none" }}
                        className={
                          location.pathname === "/how-it-works" ? "active" : ""
                        }
                        to={"/how-it-works"}
                        onClick={() => {
                          closeNavbar();
                          handleLinkClick();
                        }}
                      >
                        <a
                          className={`nav-link nav-link-one ${location.pathname === "/how-it-works"
                            ? "active"
                            : ""
                            }`} aria-label="Learn how the WashWoosh application works"
                        >
                          <span>How it works</span>
                        </a>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        style={{ textDecoration: "none" }}
                        className={
                          location.pathname === "/services" ? "active" : ""
                        }
                        to={"/services"}
                        onClick={() => {
                          closeNavbar();
                          handleLinkClick();
                        }}
                      >
                        <a
                          className={`nav-link nav-link-one ${location.pathname === "/services" ? "active" : ""
                            }`} aria-label="View WashWoosh's Doorstep Car Cleaning Services"
                        >
                          <span>Services</span>
                        </a>
                      </Link>
                    </li>
                    {/* <li className="nav-item">
        <Link
          style={{ textDecoration: "none" }}
          className={location.pathname === "/blogs" ? "active" : ""}
          to={"/blogs"}
          onClick={() => {
            closeNavbar();
            handleLinkClick();
          }}
        >
          <a className={`nav-link nav-link-one ${location.pathname === "/blogs" ? "active" : ""}`}>
            <span>Blogs</span>
          </a>
        </Link>
      </li> */}
                    <li className="nav-item">
                      <Link
                        style={{ textDecoration: "none" }}
                        className={
                          location.pathname === "/contact" && location.hash !== "#book-now"
                            ? "active"
                            : ""
                        }
                        to={"/contact"}
                        onClick={() => {
                          closeNavbar();
                          handleLinkClick();
                        }}
                      >
                        <a
                          className={`nav-link nav-link-one ${location.pathname === "/contact" && location.hash !== "#book-now"
                            ? "active"
                            : ""
                            }`} aria-label="Get in touch with WashWoosh"
                        >
                          <span>Contact</span>
                        </a>
                      </Link>
                    </li>

                    <li className="nav-item">
                      <Link
                        style={{ textDecoration: "none" }}
                        className={
                          location.pathname === "/aboutus" ? "active" : ""
                        }
                        to={"/aboutus"}
                        onClick={() => {
                          closeNavbar();
                          handleLinkClick();
                        }}
                      >
                        <a
                          className={`nav-link nav-link-one ${location.pathname === "/aboutus" ? "active" : ""
                            }`} aria-label="Learn more about WashWoosh - safe doorstep car wash service in Jaipur"
                        >
                          <span>About Us</span>
                        </a>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        style={{ textDecoration: "none" }}
                        className={
                          location.pathname === "/contact" && location.hash === "#book-now"
                            ? "active"
                            : ""
                        }
                        to={{ pathname: "/contact", hash: "#book-now" }}
                        onClick={() => {
                          closeNavbar();
                          handleLinkClick();
                        }}
                      >
                        <a
                          className={`nav-link nav-link-one ${location.pathname === "/contact" && location.hash === "#book-now"
                            ? "active"
                            : ""
                            }`} aria-label="Book the car cleaning service with washwoosh"
                        >
                          <span>Book Now</span>
                        </a>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
